import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import DeleteModel from "components/Common/FevoModels/DeleteModel";
import { connect } from "react-redux";
import ReactTable from "react-table";
import toastr from "toastr";
import axios from "../../../config/axios";
import loaderIcon from "assets/img/loader.gif";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Switch from "@material-ui/core/Switch";
import green from "@material-ui/core/colors/green";
import {
  FormControl,
  TextField,
  IconButton,
  Icon,
  Tooltip,
} from "@material-ui/core";
import { hist } from "../../..";
import { Button } from "react-bootstrap/lib/InputGroup";

const formStyle = {
  minWidth: 300,
  margin: "0 1.2rem 1.2rem 0",
};

class ManageEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      userTobeChangedIndex: null,
      userTobeChange: null,
      VIPList: [],
      limit: 500,
      offset: 0,
      showCancelModal: false,
      webinarTobeDeleted: "",
      search_event: "",
      status_category: "",
      data: null,
      statusList: [
        "SCHEDULED",
        "BOOKING_STARTED",
        "ONGOING",
        "COMPLETED",
        "ADMIN_CANCELLED",
        "USER_CANCELLED",
      ],
      loading: false,
      webinarTobeDeleted: null,
      userTobeChange: null,
      userTobeChangedIndex: null,
      showBlockUserModal: false,
      popText: "Block",
      search_user_by_email: null,

    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    axios
      .get(`users/user-type/8`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          this.setState({
            VIPList: res.data.data,
            loading: false,
            data: res.data.data,
          });
          
        }
      })
      .catch((error) => {
        if (error.response) {
          toastr.error(error.response.data.message);
        } else {
          this.setState({
            loading: false,
          });
        }
      });
  }

  editEventFunc = (event) => {
    this.props.history.push("/admin/manageevents/eventdetail", {
      event,
    });
  };

  reset = () => {
    this.setState({
      status_category: "",
      search_event: "",
      VIPList: this.props.eventListData.data,
    });
  };
  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        Header: "Full name",
        accessor: "name",
      },
      //   {
      //     Header: "Topic",
      //     accessor: "topic",
      //   },
      {
        Header: "Salutation",
        accessor: "salutation",
      },
      {
        Header: "Designation",
        accessor: "designation",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Department",
        accessor: "department",
      },
      {
        Header: "Organization",
        accessor: "organisation",
      },
      {
        Header: "Action",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (webinar) => {
          return (
            <div className="actions-center">
              {/* <Switch
                checked={webinar.original.active}
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleUserStatusChange(webinar.original, webinar.index);
                }}
              /> */}
                {/* <Button
                color="primary"
                variant="contained"
                size="small"
                style={{ minWidth: "55px", fontSize : "12px",marginLeft: "6%"}}
                className={classes.button}
                // onClick={e => {
                //   e.stopPropagation();
                //   this.props.history.push("/admin/managewebinar/webinardetail", {
                //     webinar: webinar.original
                //   });
                // }}
              >
                View
              </Button> */}

              {/* <Tooltip title="Add">
                <IconButton
                  color="primary"
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push(`/admin/vip/viplist/addtowebinar/${webinar.original.id}`, {
                        action: "AddWebinar",
                        event: webinar.original
                    });
                }}
                >
                  <Icon>add</Icon>
                </IconButton>
              </Tooltip> */}

              <Tooltip title="View">
                <IconButton
                  color="primary"
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push("/admin/vip/viplist/vipbookingdetails", {
                        action: "view",
                        event: webinar.original
                    });
                }}
                >
                  <Icon>visibility_icon</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  onClick={()=>hist.push(`/admin/vip/${webinar.original.id}`)}
                >
                  <Icon>edit_icon</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ];
    return column;
  };

  handleUserStatusChange = (userTobeChange, userTobeChangedIndex) => {
    let popText;
    if (userTobeChange.active) {
      popText = "Are you sure you want to cancel this VIP seat?";
    } else {
      popText = "Are you sure you want to approve this VIP seat?";
    }
    this.setState({
      userTobeChange,
      userTobeChangedIndex,
      showBlockUserModal: true,
      popText,
    });
  };

  handleBlockModal = () => {
    this.setState(({ showBlockUserModal }) => ({
      showBlockUserModal: !showBlockUserModal,
      userTobeChangedIndex: null,
      userTobeChange: null,
    }));
  };

  changeUserStatus = (user, index) => {
    console.log(user,'user in changeUserStatus')
   
    this.setState({
      loading: true,
    });
    let check;
    if (user.active) {
      check = "cancel";
    } else {
      check = "approve";
    }
    axios
      .put(
        `zoom/updateBasicVIPWebinar?webinar_id=${user.id}&action=${check}&registrant_id=${user.id}&email=${user.email}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (user.active) {
            toastr.success("VIP Seat Cancelled Successfully!");
            this.handleBlockModal();
            setTimeout(function() {
              window.location.reload();
            }, 2000);
          } else {
            toastr.success("VIP Seat Approved Successfully!");
            this.handleBlockModal();
            setTimeout(function() {
              window.location.reload();
            }, 2000);
          }
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });

        toastr.error(error.response.data.message);
        this.handleBlockModal();
      });
  };

  render() {
    const {
      VIPList,
      popText,
      showBlockUserModal,
      loading,
      search_event,
      data,
      search_user_by_email,
    } = this.state;

    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} alt="loader" />
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody className="table_space vip_list">
                    <FormControl style={formStyle}>
                      <TextField
                        id="standard-search"
                        label="Search VIP User by name"
                        name="search_event"
                        type="search"
                        fullWidth
                        value={search_event}
                        onChange={(event) => {
                          const { value } = event.target;
                          this.setState(
                            {
                              VIPList: data,
                            },
                            () => {
                              const newVIPList = this.state.VIPList.filter(
                                (item) =>
                                  item &&
                                  item.name
                                  &&
                                  item.name
                                    .toLowerCase()
                                    .includes(value.toLowerCase())
                              );
                              console.log(newVIPList,'newVIPList')
                              this.setState({
                                VIPList: newVIPList,
                                search_event: value.toLowerCase(),
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>

                    <FormControl style={formStyle}>
                    <TextField
                        id="standard-search"
                        label="Search VIP by Email"
                        name="search_user_by_email"
                        type="search"
                        fullWidth
                        value={search_user_by_email}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState(
                            {
                              VIPList: data,
                            },
                            () => {
                              const newList = this.state.VIPList.filter(item =>
                                item.email
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );
                              this.setState({
                                VIPList: newList,
                                search_user_by_email: value.toLowerCase()
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>

                    <ReactTable
                      data={VIPList || []}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={25}
                      pageSizeOptions={[25, 50, 100]}
                      showPaginationBottom={true}
                      minRows={0}
                      noDataText="No VIP Booking found!"
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px",
                          },
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <DeleteModel
              showModel={showBlockUserModal}
              title={popText}
              onCancel={this.handleBlockModal}
              onOk={() => {
                let { userTobeChangedIndex, userTobeChange } = this.state;
                this.changeUserStatus(userTobeChange, userTobeChangedIndex);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const ManageEventsListComponent = withStyles(extendedTablesStyle)(ManageEvents);
export default connect()(ManageEventsListComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/vipbooking/index.js